import {
    NEW_MANEJO_EXECUCAO_CADASTRO_SUCCESS,
    CANCEL_MANEJO_EXECUCAO_CADASTRO_RAPIDO_SUCCESS,
    TABLE_MANEJO_EXECUCAO_CADASTRO_PENDING,
    TABLE_MANEJO_EXECUCAO_CADASTRO_SUCCESS,
    TABLE_MANEJO_EXECUCAO_CADASTRO_FAILURE,
    LIST_MANEJO_EXECUCAO_CADASTRO_PENDING,
    LIST_MANEJO_EXECUCAO_CADASTRO_SUCCESS,
    LIST_MANEJO_EXECUCAO_CADASTRO_FAILURE,
    FIND_MANEJO_EXECUCAO_CADASTRO_PENDING,
    FIND_MANEJO_EXECUCAO_CADASTRO_SUCCESS,
    FIND_MANEJO_EXECUCAO_CADASTRO_FAILURE,
    DELETE_MANEJO_EXECUCAO_CADASTRO_PENDING,
    DELETE_MANEJO_EXECUCAO_CADASTRO_SUCCESS,
    DELETE_MANEJO_EXECUCAO_CADASTRO_FAILURE,
    CREATE_MANEJO_EXECUCAO_CADASTRO_PENDING,
    CREATE_MANEJO_EXECUCAO_CADASTRO_SUCCESS,
    CREATE_MANEJO_EXECUCAO_CADASTRO_FAILURE,
    NEW_MANEJO_EXECUCAO_CADASTRO_PENDING,
    NEW_MANEJO_EXECUCAO_BY_PLANEJAMENTO_PENDING,
} from './actionTypes';


const initialState = { list: null, loading: false }


function manejoExecucaoCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_MANEJO_EXECUCAO_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case NEW_MANEJO_EXECUCAO_CADASTRO_PENDING:
        case LIST_MANEJO_EXECUCAO_CADASTRO_PENDING:
        case FIND_MANEJO_EXECUCAO_CADASTRO_PENDING:
        case DELETE_MANEJO_EXECUCAO_CADASTRO_PENDING:
        case CREATE_MANEJO_EXECUCAO_CADASTRO_PENDING:
        case TABLE_MANEJO_EXECUCAO_CADASTRO_PENDING:
        case NEW_MANEJO_EXECUCAO_BY_PLANEJAMENTO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_MANEJO_EXECUCAO_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_MANEJO_EXECUCAO_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_MANEJO_EXECUCAO_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_MANEJO_EXECUCAO_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_MANEJO_EXECUCAO_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_MANEJO_EXECUCAO_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_MANEJO_EXECUCAO_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_MANEJO_EXECUCAO_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_MANEJO_EXECUCAO_CADASTRO_SUCCESS:
        case CREATE_MANEJO_EXECUCAO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_MANEJO_EXECUCAO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { manejoExecucaoCadastroReducer };